import { ChangeDetectionStrategy, Component, HostListener } from "@angular/core";
import { FiatActionButtonsComponent } from "../../fiat-action-buttons/fiat-action-buttons.component";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { Fiat } from "@models";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { StockTestService } from "@main-services/stock-test.service";
import { AccountService } from "@modules/account/services/account.service";
import { TooltipService } from "@main-services/tooltip.service";
import { FiatService } from "@main-services/currency";
import { UserService } from "@main-services/user.service";
import { ModalService } from "@core-services/modal.service";
import { MasterdataService } from "@core-services/masterdata.service";
import { StockTestHelperService } from "@main-services/stock-test-helper.service";
import { FiatDepositEntryService } from "@modules/+new/payments/features/fiat-deposit/infrastructure/fiat-deposit-entry.service";
import { matchesMediaQuery } from "@helpers/utils";
import { SMALL_DEVICES_WIDTH_THRESHOLD } from "@helpers/constants";
import { SendEntryPointService } from "@modules/+new/payments/features/send/domain/send-entry-point.service";
import { WalletsBalancesFacadeService } from "@modules/+new/core/wallets-balances/domain/+state/wallets-balances.facade.service";
import { UserFiatFundsService } from "@modules/shared/services/user-fiat-funds.service";
import { CheckoutNavigationService } from "@modules/checkout/services/checkout-navigation.service";
import { LaunchDarklyService } from "@core-services/launch-darkly/launch-darkly.service";

@Component({
	selector: "fiat-mobile-action-button-wrapper",
	templateUrl: "./fiat-mobile-action-button-wrapper.component.html",
	styleUrls: ["./fiat-mobile-action-button-wrapper.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class FiatMobileActionButtonWrapperComponent extends FiatActionButtonsComponent {
	public mobileWindow: boolean = false;
	public joinedActionButtonClicked: boolean = false;

	public constructor(
		protected modalService: ModalService,
		protected accountService: AccountService,
		protected fiatService: FiatService,
		protected tradableWalletListService: TradableWalletListService,
		protected userService: UserService,
		protected tradableListService: TradableListService,
		protected masterdataService: MasterdataService,
		protected tooltipService: TooltipService,
		protected stockTestService: StockTestService,
		protected stockTestHelperService: StockTestHelperService,
		protected fiatDepositEntryService: FiatDepositEntryService,
		protected sendEntryPoint: SendEntryPointService,
		protected walletBalanceFacade: WalletsBalancesFacadeService,
		protected userFiatFundsService: UserFiatFundsService,
		protected checkoutNavigationService: CheckoutNavigationService,
		protected launchDarklyService: LaunchDarklyService
	) {
		super(
			modalService,
			accountService,
			fiatService,
			tradableWalletListService,
			userService,
			tradableListService,
			masterdataService,
			tooltipService,
			stockTestService,
			stockTestHelperService,
			fiatDepositEntryService,
			sendEntryPoint,
			walletBalanceFacade,
			userFiatFundsService,
			checkoutNavigationService,
			launchDarklyService
		);
		this.onResize();
	}

	public get d_fiat(): Fiat {
		return this.accountService.getDefaultFiat();
	}

	public get exchanged(): number {
		return (this.wallet.getBalance() * this.fiat.toEuroRate()) / this.d_fiat.toEuroRate();
	}

	@HostListener("window: resize")
	public onResize(): void {
		this.mobileWindow = !matchesMediaQuery(SMALL_DEVICES_WIDTH_THRESHOLD);
	}

	public mainButtonToggle(): boolean {
		this.joinedActionButtonClicked = !this.joinedActionButtonClicked;
		return this.joinedActionButtonClicked;
	}
}
